import { render, staticRenderFns } from "./RoleDetailsCard.vue?vue&type=template&id=e6e429fc&scoped=true&"
import script from "./RoleDetailsCard.vue?vue&type=script&lang=js&"
export * from "./RoleDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./RoleDetailsCard.vue?vue&type=style&index=0&id=e6e429fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e429fc",
  null
  
)

export default component.exports